<template>
    <div class="qksm qksm1">
        <div class="nogap">
            <h4>一、收入支出总体情况说明</h4>
            <p>
                2020年度收入、支出总计{{isMoney(T1.收入.总计)}}万元，
                <span class="hide_pdf">
                    （去年决算数<reason type="money" classname="qksm money nullable" name="收支去年" v-model:value="T1.收入.总计_last"></reason>万元）
                </span>
                较上年收入、支出总计各{{growthValueText(T1.收入.总计,T1.收入.总计_last)}}万元。主要原因是：
                <reason type="textarea" classname="qksm widest" name="原因收支总计" v-model:value="qksm['原因收支总计']"></reason>
                其中：
            </p>
        </div>
        <div id="myChart1" class="echart" v-if="!isPdf && $parent.isData"></div>
        <div id="myChart1" class="echart" v-if="isPdf"></div>
        <div class="nogap">
            <p><b>（一）收入总计{{isMoney(T1.收入.总计)}}万元，包括：</b></p>
            <p v-if="num(T1.收入.项_1)>0">
                {{oneArr[0]}}．一般公共预算财政拨款收入{{isMoney(T1.收入.项_1)}}万元，
                <template v-if="num(T1.收入.项_1)!=0">
                    为本年度从本级财政部门取得的一般公共预算财政拨款。
                </template>
                <template v-else>
                    本年度未从本级财政部门取得的一般公共预算财政拨款。
                </template>
                <span class="hide_pdf">
                    （去年决算数<reason type="money" classname="qksm money nullable" name="收入项_1_去年" v-model:value="T1.收入.项_1_last"></reason>万元）
                </span>
                较上年{{growthValueText(T1.收入.项_1,T1.收入.项_1_last)}}万元，
                <template v-if="num(T1.收入.项_1).toFixed(2)==num(T1.收入.项_1_last).toFixed(2)">
                    与上年决算数相同。
                </template>
                <template v-else>
                    <template v-if="T1.收入.项_1!=T1.收入.项_1_last && num(T1.收入.项_1_last)==0">
                        上年无决算
                    </template>
                    <template v-else>
                        {{growthRatioText(T1.收入.项_1,T1.收入.项_1_last)}}
                    </template>
                    ，主要原因是
                    <reason type="textarea" classname="qksm widest" name="原因收入项_1" v-model:value="qksm['原因收入项_1']"></reason>
                </template>
            </p>
            <p v-if="num(T1.收入.项_2)>0">
                {{oneArr[1]}}．政府性基金预算财政拨款收入{{isMoney(T1.收入.项_2)}}万元，
                <template v-if="num(T1.收入.项_2)!=0">
                    为本年度从本级财政部门取得的政府性基金预算财政拨款。
                </template>
                <template v-else>
                    本年度未从本级财政部门取得的政府性基金预算财政拨款。
                </template>
                <span class="hide_pdf">
                    （去年决算数<reason type="money" classname="qksm money nullable" name="收入项_2_去年" v-model:value="T1.收入.项_2_last"></reason>万元）
                </span>
                较上年{{growthValueText(T1.收入.项_2,T1.收入.项_2_last)}}万元，
                <template v-if="num(T1.收入.项_2).toFixed(2)==num(T1.收入.项_2_last).toFixed(2)">
                    与上年决算数相同。
                </template>
                <template v-else>
                    <template v-if="T1.收入.项_2!=T1.收入.项_2_last && num(T1.收入.项_2_last)==0">
                        上年无决算
                    </template>
                    <template v-else>
                        {{growthRatioText(T1.收入.项_2,T1.收入.项_2_last)}}
                    </template>
                    ，主要原因是
                    <reason type="textarea" classname="qksm widest" name="原因收入项_2" v-model:value="qksm['原因收入项_2']"></reason>
                </template>
            </p>
            <p v-if="num(T1.收入.项_3)>0">
                {{oneArr[2]}}．国有资本经营预算财政拨款收入{{isMoney(T1.收入.项_3)}}万元，
                <template v-if="num(T1.收入.项_3)!=0">
                    为本年度从本级财政部门取得的国有资本经营预算财政拨款。
                </template>
                <template v-else>
                    本年度未从本级财政部门取得的国有资本经营预算财政拨款。
                </template>
                <span class="hide_pdf">
                    （去年决算数<reason type="money" classname="qksm money nullable" name="收入项_3_去年" v-model:value="T1.收入.项_3_last"></reason>万元）
                </span>
                较上年{{growthValueText(T1.收入.项_3,T1.收入.项_3_last)}}万元，
                <template v-if="num(T1.收入.项_3).toFixed(2)==num(T1.收入.项_3_last).toFixed(2)">
                    与上年决算数相同。
                </template>
                <template v-else>
                    <template v-if="T1.收入.项_3!=T1.收入.项_3_last && num(T1.收入.项_3_last)==0">
                        上年无决算
                    </template>
                    <template v-else>
                        {{growthRatioText(T1.收入.项_3,T1.收入.项_3_last)}}
                    </template>
                    ，主要原因是
                    <reason type="textarea" classname="qksm widest" name="原因收入项_3" v-model:value="qksm['原因收入项_3']"></reason>
                </template>
            </p>
            <p v-if="num(T1.收入.项_4)>0">
                {{oneArr[3]}}．上级补助收入{{isMoney(T1.收入.项_4)}}万元，
                <reason v-if="num(T1.收入.项_4)!=0" type="textarea" classname="qksm widest" name="上级补助收入单位" v-model:value="qksm['上级补助收入单位']" placeholder="为xxx等事业单位从主管部门和上级单位取得的非财政补助资金"></reason>
                <template v-else>
                    本年度无事业单位从主管部门和上级单位取得的非财政补助资金。
                </template>
                <span class="hide_pdf">
                    （去年决算数<reason type="money" classname="qksm money nullable" name="收入项_4_去年" v-model:value="T1.收入.项_4_last"></reason>万元）
                </span>
                较上年{{growthValueText(T1.收入.项_4,T1.收入.项_4_last)}}万元，
                <template v-if="num(T1.收入.项_4).toFixed(2)==num(T1.收入.项_4_last).toFixed(2)">
                    与上年决算数相同。
                </template>
                <template v-else>
                    <template v-if="T1.收入.项_4!=T1.收入.项_4_last && num(T1.收入.项_4_last)==0">
                        上年无决算
                    </template>
                    <template v-else>
                        {{growthRatioText(T1.收入.项_4,T1.收入.项_4_last)}}
                    </template>
                    ，主要原因是
                    <reason type="textarea" classname="qksm widest" name="原因收入项_4" v-model:value="qksm['原因收入项_4']"></reason>
                </template>
            </p>
            <p v-if="num(T1.收入.项_5)>0">
                {{oneArr[4]}}．事业收入{{isMoney(T1.收入.项_5)}}万元，
                <reason v-if="num(T1.收入.项_5)!=0" type="textarea" classname="qksm widest" name="事业收入单位" v-model:value="qksm['事业收入单位']" placeholder="为xxx等事业单位开展xx专业业务活动及其辅助活动取得的收入。"></reason>
                <template v-else>
                    本年度无事业单位开展专业业务活动及其辅助活动取得的收入。
                </template>
                <span class="hide_pdf">
                    （去年决算数<reason type="money" classname="qksm money nullable" name="收入项_5_去年" v-model:value="T1.收入.项_5_last"></reason>万元）
                </span>
                较上年{{growthValueText(T1.收入.项_5,T1.收入.项_5_last)}}万元，
                <template v-if="num(T1.收入.项_5).toFixed(2)==num(T1.收入.项_5_last).toFixed(2)">
                    与上年决算数相同。
                </template>
                <template v-else>
                    <template v-if="T1.收入.项_5!=T1.收入.项_5_last && num(T1.收入.项_5_last)==0">
                        上年无决算
                    </template>
                    <template v-else>
                        {{growthRatioText(T1.收入.项_5,T1.收入.项_5_last)}}
                    </template>
                    ，主要原因是
                    <reason type="textarea" classname="qksm widest" name="原因收入项_5" v-model:value="qksm['原因收入项_5']"></reason>
                </template>
            </p>
            <p v-if="num(T1.收入.项_6)>0">
                {{oneArr[5]}}．经营收入{{isMoney(T1.收入.项_6)}}万元，
                <reason type="textarea" v-if="num(T1.收入.项_6)!=0" classname="qksm widest" name="经营收入单位" v-model:value="qksm['经营收入单位']" placeholder="为xxx等事业单位在专业业务活动及其辅助活动之外开展非独立核算经营活动取得的收入。"></reason>
                <template v-else>
                    本年度无事业单位在专业业务活动及其辅助活动之外开展非独立核算经营活动取得的收入。
                </template>
                <span class="hide_pdf">
                    （去年决算数<reason type="money" classname="qksm money nullable" name="收入项_6_去年" v-model:value="T1.收入.项_6_last"></reason>万元）
                </span>
                较上年{{growthValueText(T1.收入.项_6,T1.收入.项_6_last)}}万元，
                <template v-if="num(T1.收入.项_6).toFixed(2)==num(T1.收入.项_6_last).toFixed(2)">
                    与上年决算数相同。
                </template>
                <template v-else>
                    <template v-if="T1.收入.项_6!=T1.收入.项_6_last && num(T1.收入.项_6_last)==0">
                        上年无决算
                    </template>
                    <template v-else>
                        {{growthRatioText(T1.收入.项_6,T1.收入.项_6_last)}}
                    </template>
                    ，主要原因是
                    <reason type="textarea" classname="qksm widest" name="原因收入项_6" v-model:value="qksm['原因收入项_6']"></reason>
                </template>
            </p>
            <p v-if="num(T1.收入.项_7)>0">
                {{oneArr[6]}}．附属单位上缴收入{{isMoney(T1.收入.项_7)}}万元，
                <reason v-if="num(T1.收入.项_7)!=0" type="textarea" classname="qksm widest" name="附属单位上缴收入单位" v-model:value="qksm['附属单位上缴收入单位']" placeholder="为xxx等事业单位附属独立核算xxx单位按照有关规定上缴的收入"></reason>
                <template v-else>
                    本年度无事业单位附属独立核算单位按照有关规定上缴的收入。
                </template>
                <span class="hide_pdf">
                    （去年决算数<reason type="money" classname="qksm money nullable" name="收入项_7_去年" v-model:value="T1.收入.项_7_last"></reason>万元）
                </span>
                较上年{{growthValueText(T1.收入.项_7,T1.收入.项_7_last)}}万元，
                <template v-if="num(T1.收入.项_7).toFixed(2)==num(T1.收入.项_7_last).toFixed(2)">
                    与上年决算数相同。
                </template>
                <template v-else>
                    <template v-if="T1.收入.项_7!=T1.收入.项_7_last && num(T1.收入.项_7_last)==0">
                        上年无决算
                    </template>
                    <template v-else>
                        {{growthRatioText(T1.收入.项_7,T1.收入.项_7_last)}}
                    </template>
                    ，主要原因是
                    <reason type="textarea" classname="qksm widest" name="原因收入项_7" v-model:value="qksm['原因收入项_7']"></reason>
                </template>
            </p>
            <p v-if="num(T1.收入.项_8)>0">
                {{oneArr[7]}}．其他收入{{isMoney(T1.收入.项_8)}}万元，
                <template v-if="num(T1.收入.项_8)!=0">
                    为单位取得的除上述收入以外的各项收入，主要为
                    <reason type="textarea" classname="qksm widest" name="其他收入单位" v-model:value="qksm['其他收入单位']" placeholder="xxx单位取得的xx收入"></reason>
                </template>
                <template v-else>
                    本年度无单位取得的除上述收入以外的各项收入。
                </template>
                <span class="hide_pdf">
                    （去年决算数<reason type="money" classname="qksm money nullable" name="收入项_8_去年" v-model:value="T1.收入.项_8_last"></reason>万元）
                </span>
                较上年{{growthValueText(T1.收入.项_8,T1.收入.项_8_last)}}万元，
                <template v-if="num(T1.收入.项_8).toFixed(2)==num(T1.收入.项_8_last).toFixed(2)">
                    与上年决算数相同。
                </template>
                <template v-else>
                    <template v-if="T1.收入.项_8!=T1.收入.项_8_last && num(T1.收入.项_8_last)==0">
                        上年无决算
                    </template>
                    <template v-else>
                        {{growthRatioText(T1.收入.项_8,T1.收入.项_8_last)}}
                    </template>
                    ，主要原因是
                    <reason type="textarea" classname="qksm widest" name="原因收入项_8" v-model:value="qksm['原因收入项_8']"></reason>
                </template>
            </p>
            <p v-if="num(T1.收入.项_9)>0">
                {{oneArr[8]}}．使用非财政拨款结余{{isMoney(T1.收入.项_9)}}万元，
                <reason v-if="num(T1.收入.项_9)!=0" type="textarea" classname="qksm widest" name="非财政拨款结余" v-model:value="qksm['非财政拨款结余']" placeholder="为xxx事业单位按照预算管理要求使用非财政拨款结余弥补当年收支差额的资金"></reason>
                <template v-else>
                    本年度无事业单位按照预算管理要求使用非财政拨款结余弥补当年收支差额的资金。
                </template>
            </p>
            <p v-if="num(T1.收入.项_10)>0">
                {{oneArr[9]}}．年初结转和结余{{isMoney(T1.收入.项_10)}}万元，
                <reason v-if="num(T1.收入.项_10)!=0" type="textarea" classname="qksm widest" name="年初结转单位" v-model:value="qksm['年初结转单位']" placeholder="为xxx单位上年结转本年使用的xxx等资金"></reason>
                <template v-else>
                    本年度无单位上年结转本年使用的资金。
                </template>

            </p>
            <p><b>（二）支出总计{{isMoney(T1.支出.总计)}}万元，包括：</b></p>
            <template v-for="(item,idx) in T1.支出.项目">
                <p>
                    {{idx+1}}.{{item.name}}（类）{{isMoney(item.value)}}万元，
                    占{{getPercentValue(T1.支出.项目.map(e=>e.value), idx, 2)}}，
                    主要用于{{$parent.typeText == "单位" && item.name.indexOf('其他支出')!='-1' ? "" : $store.state.divData.divname}}{{userFor(item.name)}}
                    <reason v-if="item.name.indexOf('其他支出')!='-1'" type="textarea" classname="qksm widest" name="其他支出某方面" v-model:value="qksm['其他支出某方面']" placeholder="xxx方面的支出"></reason>
                    <template v-if="item.name.indexOf('抗疫特别国债')!='-1'">
                        本科目为2020年度新增科目，无与上年对比数据。
                    </template>
                    <span class="hide_pdf">
                        （去年决算数<reason type="money" classname="qksm money nullable" :name="item.name+'支出去年'" v-model:value="item.valuelast"></reason>万元）
                    </span>
                    较上年{{growthValueText(item.value,item.valuelast)}}万元，
                    <template v-if="num(item.value).toFixed(2)==num(item.valuelast).toFixed(2)">
                        增长0%，主要原因是与上年决算数相同。
                    </template>
                    <template v-else>
                        <template v-if="item.value!=item.valuelast && num(item.valuelast)==0">
                            上年无决算
                        </template>
                        <template v-else>
                            {{growthRatioText(item.value,item.valuelast)}}
                        </template>
                        ，主要原因是
                        <reason type="textarea" classname="qksm widest" :name="item.name+'支出原因'" v-model:value="qksm[item.name+'支出原因']"></reason>
                    </template>
                </p>
            </template>
            <p>
                {{T1.支出.项目.length+1}}.结余分配{{isMoney(T1.支出.结余分配.value)}}万元，主要是{{$store.state.divData.divname}}{{userFor('结余分配')}}
                <span class="hide_pdf">
                    （去年决算数<reason type="money" classname="qksm money nullable" name="结余分配支出去年" v-model:value="T1.支出.结余分配.valuelast"></reason>万元）
                </span>
                较上年{{growthValueText(T1.支出.结余分配.value,T1.支出.结余分配.valuelast)}}万元，
                <template v-if="num(T1.支出.结余分配.value).toFixed(2)==num(T1.支出.结余分配.valuelast).toFixed(2)">
                    增长0%，主要原因是与上年决算数相同。
                </template>
                <template v-else>
                    <template v-if="T1.支出.结余分配.value!=T1.支出.结余分配.valuelast && num(T1.支出.结余分配.valuelast)==0">
                        上年无决算
                    </template>
                    <template v-else>
                        {{growthRatioText(T1.支出.结余分配.value,T1.支出.结余分配.valuelast)}}
                    </template>
                    ，主要原因是
                    <reason type="textarea" classname="qksm widest" name="结余分配支出原因" v-model:value="qksm['结余分配支出原因']"></reason>
                </template>
            </p>
            <p>{{T1.支出.项目.length+2}}.年末结转和结余{{isMoney(T1.支出.年末结转和结余)}}万元，为{{$store.state.divData.divname}}{{userFor('年末结转和结余')}}</p>
        </div>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm1",
        data() {
            var qksm = this.$store.state.divData.qksm;
            if (qksm['收支去年'])
                this.T1['收入']['总计_last'] = qksm['收支去年'];
            for (var i = 1; i <= 8; i++) {
                if (qksm['收入项_' + i + '_去年'])
                    this.T1['收入']['项_' + i + '_last'] = qksm['收入项_' + i + '_去年'];
            }
            for (let a of this.T1.支出.项目) {
                let v = qksm[a.name + '支出去年'];
                if (v)
                    a.valuelast = v;
                else {
                    a.valuelast = (this.T1.支出.项目_last.find(e => e.name == a.name) || { value: 0 }).value;
                }
            }
            qksm['结余分配支出原因'] = this.pickOneOf(qksm['结余分配支出原因'], qksm["结余分配支出原因"+"\'"])
            if (qksm['结余分配支出去年']) {
                this.T1.支出.结余分配.valuelast = qksm['结余分配支出去年']
            }
            var arr = []
            var arrNum=1
            for (var i = 1; i <= 10; i++) {
                if (this.T1['收入']['项_' + i] > 0) {
                    arr.push(arrNum++)
                } else {
                    arr.push(0)
                }
            }
            console.log(arr)
            return {
                isPdf: this.$parent.isPdf,
                qksm: qksm,
                oneArr: arr,
            }
        },
        props: {
            T1: {
                type: Object,
                default: "",
            },
        },
        components: {
            reason,
        },
        computed: {
            总计_last() {
                return this.isMoney(this.T1.收入.总计_last)
            }
        },
        watch: {
            总计_last() {
                this.$parent.isChart()
            }
        },
        methods: {
            userFor(name) {
                var bm = this.$parent.typeText == "单位" ? "单位" : "及所属单位"
                if (name.indexOf("一般公共服务支出") != -1) {
                    return bm + "保障机构正常运转、开展公共管理活动所发生的基本支出和项目支出。"
                } else if (name.indexOf("国防支出") != -1) {
                    return bm + "现役部队、国防动员等方面的支出。"
                } else if (name.indexOf("公共安全") != -1) {
                    return bm + "维护社会公共安全方面的支出。"
                } else if (name.indexOf("教育支出") != -1) {
                    return bm + "教育事务方面的支出。"
                } else if (name.indexOf("科学技术") != -1) {
                    return bm + "科学技术管理事务、基础应用研究、科学技术普及、等方面的支出。"
                } else if (name.indexOf("文化旅游体育与传媒") != -1) {
                    return bm + "的文化、旅游、文物、体育、新闻出版电影、广播电视等方面的支出。"
                } else if (name.indexOf("社会保障和就业") != -1) {
                    return bm + "的人力资源和社会保障和管理事务、民政管理事务、离退休人员经费、就业补助、抚恤、退役安置、社会福利等方面的支出。"
                } else if (name.indexOf("卫生健康") != -1) {
                    return bm + "的卫生健康管理事务、公立医院、基层医疗卫生机构、公共卫生、计划生育事务、行政事业单位医疗等方面的支出。"
                } else if (name.indexOf("节能环保") != -1) {
                    return bm + "的环境保护管理事务、环境监测与监察、污染防治、自然生态保护、退耕还林、退牧还草等方面的支出。"
                } else if (name.indexOf("城乡社区") != -1) {
                    return bm + "的城乡社区规划与管理、城乡社区公共设施、城乡社区环境卫生、建设市场管理与监督等方面的支出。"
                } else if (name.indexOf("农林水") != -1) {
                    return bm + "的农业农村、林业和草原、水利、扶贫、农村综合改革等方面的支出。"
                } else if (name.indexOf("交通运输") != -1) {
                    return bm + "的公路水路运输、铁路运输、民用航空运输、车辆购置税等方面的支出。"
                } else if (name.indexOf("资源勘探工业信息") != -1) {
                    return bm + "的资源勘探开发、制造业、工业和信息产业监督、支持中小企业发展和管理等方面的支出。"
                } else if (name.indexOf("商业服务业") != -1) {
                    return bm + "的商业流通事务、涉外发展服务等方面的支出。"
                } else if (name.indexOf("金融支出") != -1) {
                    return bm + "的金融部门行政监管、金融发展调控等方面的支出。"
                } else if (name.indexOf("自然资源海洋气象") != -1) {
                    return bm + "的自然资源事务、气象事务等方面的支出。"
                } else if (name.indexOf("住房保障") != -1) {
                    return bm + "的保障性安居工程、住房改革、城乡社区住宅等方面的支出。"
                } else if (name.indexOf("粮油物资储备") != -1) {
                    return bm + "的粮油事务、物资事务、能源储备、粮油储备及重要商品储备等方面的支出。"
                } else if (name.indexOf("国有资本经营预算") != -1) {
                    return this.$parent.typeText == "单位" ? "单位" : "" + "解决历史遗留问题及改革成本支出、国有企业资本金注入及政策性补贴等方面的支出。"
                } else if (name.indexOf("灾害防治及应急管理") != -1) {
                    return bm + "的应急管理事务、消防事务、煤矿安全、地震事务、自然灾害防治等方面的支出。"
                } else if (name.indexOf("其他支出") != -1) {
                    return this.$parent.typeText == "部门" ? "及所属单位的" : ""
                } else if (name.indexOf("抗疫特别国债安排") != -1) {
                    return "基础设施建设及抗疫相关等方面的支出。"
                } else if (name.indexOf("结余分配") != -1) {
                    return "等事业单位缴纳企业所得税以及从非财政拨款结余或经营结余中提取各类结余资金等。"
                } else if (name.indexOf("年末结转和结余") != -1) {
                    return "等单位结转下年的基本支出结转、项目支出结转和结余、经营结余。"
                }
            }
        }
    };
</script>